import { createAvoidLibObj } from './common.js'; 
import initAvoid from "./generated/libavoid.js";

export const AvoidLib = createAvoidLibObj(initAvoid);
